module.exports = __webpack_public_path__ + "static/media/facturas_white.d9b3a368.svg";